import React, { Component } from "react";
import FlexView from "react-flexview";
import Button from "../../../../modules/commons/Button";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import { defaultTableChange } from "../../../../modules/custom/customTable";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import { removeNullFields } from "../../../common/mapper";
import FormDetailPDI from "../common/formDetailPDI";

class SudahPDI extends Component {
  searchOptions = [
    {
      label: "Nomor Mesin",
      value: "engineNumber",
    },
    {
      label: "Kode Varian",
      value: "variantCode",
    },
  ];

  tableColumns = [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;
          return <>{rowNumber}</>;
        },
      },
    },
    {
      name: "pdiNo",
      label: "No. PDI",
    },
    { name: "pdiDate", label: "Tanggal PDI" },
    { name: "salesFakturNo", label: "No. FJ" },
    { name: "salesFakturDate", label: "Tanggal FJ" },
    { name: "variant.kodeVariant", label: "Kode Varian" },
    { name: "variant.namaVariant", label: "Nama Varian" },
    { name: "warna.kodeWarna", label: "Kode Warna" },
    { name: "warna.namaWarnaKomersil", label: "Nama Warna" },
    { name: "engineNumber", label: "Nomor Mesin" },
    { name: "frameNumber", label: "Nomor Rangka" },
    { name: "pdiStatus", label: "Status" },
    {
      name: "pdiNo",
      label: "Aksi",
      options: {
        customBodyRender: (val) => (
          <Button
            className="btnAct"
            style={{ marginRight: 15, backgroundColor: "transparent" }}
            onClick={() => this.handleDetailVisibility(val)}
          >
            <i
              className="fa fa-lg fa-eye"
              style={{
                backgroundColor: "transparent",
                color: "red",
                fontSize: 20,
              }}
            />
          </Button>
        ),
      },
    },
  ];

  constructor(props) {
    super(props);
    this.state = {
      detailId: "",
      searchData: {},
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevState.searchData?.key !== this.state.searchData?.key &&
      this.state.searchData?.key === null
    ) {
      this.setState((prevValue) => ({
        ...prevValue,
        searchData: { ...prevValue.searchData, value: null },
      }));
    }
  }

  handleSearch = () => {
    let { searchData } = this.state;
    let request;
    if (searchData?.value) {
      request = removeNullFields({
        ...this.state.searchData,
        key: this.state.searchData?.key?.value,
      });
    }

    this.props.onFetchData(request, 1, this.props.state.pagination.limit);
  };

  handleDetailVisibility = (id) => {
    this.setState((prevValue) => ({ ...prevValue, detailId: id }));
  };

  handleChangePage = (tableState) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      pagination: {
        page: 1,
        totalData: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  render() {
    return (
      <div>
        <FlexView
          vAlignContent="center"
          hAlignContent="right"
          style={{ gap: "10px", marginBottom: "15px" }}
        >
          <FlexView vAlignContent="center" style={{ gap: "10px" }}>
            <p>Pilih</p>
            <SimpleDDL
              id="select_options_nomor_mesin"
              name="nomorMesin"
              box="search"
              containerclassname="margin-bottom-none width width-250px"
              isClearable
              options={this.searchOptions}
              value={this.state.searchData?.key}
              onChange={(value) =>
                this.setState((prevValue) => ({
                  ...prevValue,
                  searchData: {
                    ...prevValue.searchData,
                    key: value,
                  },
                }))
              }
            />
          </FlexView>
          <FlexView vAlignContent="center" style={{ gap: "10px" }}>
            <p>Cari</p>
            <SimpleInput
              id="input_text_cari"
              name="cari"
              containerclassname="margin-bottom-none"
              value={this.state.searchData?.value}
              readOnly={!this.state.searchData?.key}
              onChange={({ target }) =>
                this.setState((prevValue) => ({
                  ...prevValue,
                  searchData: {
                    ...prevValue.searchData,
                    value: target.value,
                  },
                }))
              }
            />
          </FlexView>
          <SimpleButton className="margin-top-5px" onClick={this.handleSearch}>
            Cari
          </SimpleButton>
        </FlexView>
        <SimpleDataTable
          toCount={this.props.state.pagination.totalData}
          data={this.props.state.sudahPDIData}
          columns={this.tableColumns}
          rowsPerPage={this.props.state.pagination.limit}
          page={this.props.state.pagination.page - 1}
          options={defaultTableChange(
            this.handleChangePage,
            this.handleRowsPerPage
          )}
        />
        {this.state.detailId && (
          <FormDetailPDI
            userAccess={this.props.userAccess}
            id={this.state.detailId}
            done={true}
            onClickClose={this.handleDetailVisibility}
          />
        )}
      </div>
    );
  }
}

export default SudahPDI;
